import {http} from '@/http'

export default {
  listDailyConversionSums(params) {
    return http.get('api/v1/conversion/daily/sum', {params})
  }
}
